import React from 'react';
import PropTypes from 'prop-types';
import { RadioCheckList } from 'ui-components/components/radio-check-list';
import { RadioCheckListItem } from 'ui-components/components/radio-check-list/radio-check-list-item';
import { FormattedMessage } from 'react-intl';
import { useStoreUpdateContext } from './context';
import messages from './messages';

import style from './style.module.less';

const ProductsTab = ({ products }) => {
  const { updateStoreSetting } = useStoreUpdateContext();
  const { createNewProducts, matchProductByName, createAdjustmentProducts } = products;

  const GROUP_NAME = 'products';
  const updateNewProducts = (value) => updateStoreSetting(GROUP_NAME, 'createNewProducts', value);
  const updateMatching = (value) => updateStoreSetting(GROUP_NAME, 'matchProductByName', value);
  const updateCouponReports = (value) => updateStoreSetting(GROUP_NAME, 'createAdjustmentProducts', value);

  return (
    <div className={style['tab-content']}>
      <div className={style['tab-header']}>
        <FormattedMessage {...messages.productTabDescription} />
      </div>

      <div className={style['product-setting']}>
        <div className={style['product-setting-header']}>
          <h2>
            <FormattedMessage {...messages.createNewProductLabel} />
          </h2>
        </div>
        <div className={style['product-setting-radio']}>
          <RadioCheckList>
            <RadioCheckListItem isChecked={createNewProducts} onChecked={() => updateNewProducts(true)}>
              <FormattedMessage {...messages.createNewProductRecordLabel} />
            </RadioCheckListItem>
            <RadioCheckListItem isChecked={!createNewProducts} onChecked={() => updateNewProducts(false)}>
              <FormattedMessage {...messages.doNotCreateProductRecord} />
            </RadioCheckListItem>
          </RadioCheckList>
        </div>
      </div>

      <div className={style['product-setting']}>
        <div className={style['product-setting-header']}>
          <h2>
            <FormattedMessage {...messages.productIdentificationLabel} />
          </h2>
        </div>
        <div className={style['product-setting-radio']}>
          <RadioCheckList>
            <RadioCheckListItem isChecked={!matchProductByName} onChecked={() => updateMatching(false)}>
              <FormattedMessage
                {...messages.productSku}
                values={{
                  strong: (chunks) => <strong>{chunks}</strong>,
                }}
              />
            </RadioCheckListItem>
            <RadioCheckListItem isChecked={matchProductByName} onChecked={() => updateMatching(true)}>
              <FormattedMessage
                {...messages.productName}
                values={{
                  strong: (chunks) => <strong>{chunks}</strong>,
                }}
              />
            </RadioCheckListItem>
          </RadioCheckList>
        </div>
      </div>

      <div className={style['product-setting']}>
        <div className={style['product-setting-header']}>
          <h2>
            <FormattedMessage {...messages.couponsDiscountsLabel} />
          </h2>
        </div>
        <div className={style['product-setting-radio']}>
          <RadioCheckList>
            <RadioCheckListItem isChecked={createAdjustmentProducts} onChecked={() => updateCouponReports(true)}>
              <FormattedMessage
                {...messages.couponsNotIncluded}
                values={{
                  strong: (chunks) => <strong>{chunks}</strong>,
                }}
              />
            </RadioCheckListItem>
            <RadioCheckListItem isChecked={!createAdjustmentProducts} onChecked={() => updateCouponReports(false)}>
              <FormattedMessage
                {...messages.couponsIncluded}
                values={{
                  strong: (chunks) => <strong>{chunks}</strong>,
                }}
              />
            </RadioCheckListItem>
          </RadioCheckList>
        </div>
      </div>
    </div>
  );
};

ProductsTab.propTypes = {
  products: PropTypes.object.isRequired,
};

export default ProductsTab;
